/**
 * Utility for determining source of element focus.
 *
 * @export
 * @enum {number}
 */
var FocusSource;
(function (FocusSource) {
    FocusSource["Mouse"] = "mouse";
    FocusSource["Keyboard"] = "key";
    FocusSource["Touch"] = "touch";
})(FocusSource || (FocusSource = {}));

export { FocusSource as F };
